import "@irati/types/global"
import {MutationOptions as BaseMutationOptions, QueryOptions as BaseQueryOptions, OperationVariables, ApolloProvider} from "@apollo/client"

export type {QueryHookOptions, DataProxy, PureQueryOptions} from "@apollo/client"
export type {ApolloLoad, PBApolloError} from "./helpers/hookShared"
export type {UseQueryExtend, UseQueryResult} from "./useQuery"
export {createUseQuery} from "./useQuery"
export {useQuerys} from "./helpers/useQuerys"
export type {UseQueriesResult} from "./helpers/useQuerys"
export {createUseLazyQuery} from "./useLazyQuery"
export {useFetchMore} from "./useFetchMore"
export type {UseMutationExtractor} from "./useMutation"
export {createUseMutation} from "./useMutation"

/* eslint-disable import/first */
// do not move these up, native will break, there be circles in there
import client from "./client"
import Query from "./Query"
import Mutation from "./Mutation"
import pagination, {emptyList} from "./helpers/pagination"
import hasMorePagination from "./helpers/hasMorePagination"
import cursorPagination from "./helpers/cursorPagination"
/* eslint-enable import/first */

export type MutationOptions<T = any, TVariables = OperationVariables> = Omit<BaseMutationOptions<T, TVariables>, "mutation" | "variables">

export type QueryOptions<TVariables = OperationVariables> = Omit<BaseQueryOptions<TVariables>, "query" | "variables">

/**
 * extract the `data` type from an apollo like hook, i.e something that returns a `data` field
 */
export type InferApolloData<T extends (...x: any) => {data: any}> = NonNullable<ReturnType<T>["data"]>

export {gqlService} from "./clientService"
export {Query, Mutation, ApolloProvider, pagination, hasMorePagination, cursorPagination, emptyList}
export default client
